/**
 * File: MobileNavigation.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.0
 * Created: 2026-02-13
 * Last Updated: 2026-02-13
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Link } from "react-router-dom";
import { useState } from "react";

// Local project files
import { IconButton } from "../ui/Buttons";

// Icons
import { IoIosClose } from "react-icons/io";
import { IoIosMenu } from "react-icons/io";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function MobileNavigation() {
    const [isOpen, setIsOpen] = useState(false);
    const [toggleAnimation, setToggleAnimation] = useState("");

    const handleIsOpen = () => {
        setToggleAnimation(
            isOpen
                ? "mobile-navigation__toggle--close"
                : "mobile-navigation__toggle--open",
        );
        setIsOpen((prev) => !prev);
        setTimeout(() => {
            setToggleAnimation("");
        }, 300);
    };

    return (
        <>
            <div className={`mobile-navigation__toggle ${toggleAnimation}`}>
                <IconButton
                    icon={isOpen ? IoIosClose : IoIosMenu}
                    onClick={handleIsOpen}
                    size="32"
                />
            </div>
            {isOpen && (
                <>
                    <div
                        className="mobile-navigation__overlay"
                        onClick={handleIsOpen}
                    ></div>
                    <nav className="mobile-navigation">
                        <div className="mobile-navigation__content">
                            <Link
                                to="/products"
                                className="mobile-navigation__link"
                                onClick={handleIsOpen}
                            >
                                PRODUCTS
                            </Link>
                            <Link
                                to="/services"
                                className="mobile-navigation__link"
                                onClick={handleIsOpen}
                            >
                                SERVICES
                            </Link>
                        </div>
                    </nav>
                </>
            )}
        </>
    );
}

export default MobileNavigation;
